import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "px-3 py-1 container-fluid"
};
const _hoisted_2 = {
  class: "sidenav-toggler-inner"
};
const _hoisted_3 = {
  class: "navbar-nav justify-content-end"
};
const _hoisted_4 = {
  class: "nav-item d-xl-none ps-3 d-flex align-items-center"
};
const _hoisted_5 = {
  class: "sidenav-toggler-inner"
};
import { useLayoutStore } from '@/store/modules/layout';
import router from '@/router';
import { useAccountStore } from '@/store/modules/account';
import { useRoute } from 'vue-router';
import { computed, onBeforeMount, ref } from 'vue';
export default {
  __name: 'Navbar',
  setup(__props) {
    const route = useRoute();
    const layoutStore = useLayoutStore();
    const accountStore = useAccountStore();
    onBeforeMount(() => {
      toggleNavigationOnMobile();
    });
    const showMenu = ref(false);
    const name = accountStore.loginData?.name ?? '관리자';
    const currentRouteName = route.name;
    const isRTL = layoutStore.getIsRtl;
    const isNavFixed = layoutStore.getIsNavFixed;
    const darkMode = layoutStore.getDarkMode;
    const currentDirectory = computed(() => {
      let dir = route.path.split('/')[1];
      if (dir.length > 0) {
        return dir.charAt(0).toUpperCase() + dir.slice(1);
      }
    });
    const toggleNavigationOnMobile = () => {
      if (window.innerWidth < 1200) {
        navbarMinimize();
      }
    };
    const navbarMinimize = () => {
      const sidenav_show = document.querySelector('#app');
      const logoImg = document.getElementById('logo_img');
      if (sidenav_show.classList.contains('g-sidenav-show') && sidenav_show.classList.contains('g-sidenav-hidden')) {
        sidenav_show.classList.add('g-sidenav-pinned');
        sidenav_show.classList.remove('g-sidenav-hidden');
        logoImg.style.display = 'block';
        layoutStore.isPinned = true;
      } else if (sidenav_show.classList.contains('g-sidenav-show') && sidenav_show.classList.contains('g-sidenav-pinned')) {
        sidenav_show.classList.add('g-sidenav-hidden');
        sidenav_show.classList.remove('g-sidenav-pinned');
        logoImg.style.display = 'none';
        layoutStore.isPinned = false;
      } else if (sidenav_show.classList.contains('g-sidenav-show') && window.innerWidth < 1200) {
        sidenav_show.classList.add('g-sidenav-pinned');
        layoutStore.isPinned = true;
      } else {
        sidenav_show.classList.add('g-sidenav-hidden');
        layoutStore.isPinned = true;
        logoImg.style.display = 'none';
      }
    };
    const toggleConfigurator = () => {
      layoutStore.showConfig = !layoutStore.showConfig;
    };
    const toggleSidebarColor = () => {
      layoutStore.toggleSidebarColor();
    };
    const changePassword = () => {
      router.push('/change-password');
    };
    const logout = () => {
      if (!confirm('로그아웃 하시겠습니까?')) return false;
      accountStore.logout();
      router.replace('/');
    };

    // import { mapState, mapMutations, mapActions } from 'vuex';
    // export default {
    //   name: 'Navbar',
    //   components: {},
    //   data() {
    //     return {
    //       showMenu: false
    //     };
    //   },
    //   computed: {
    //     ...mapState('layout', ['isRTL', 'isNavFixed', 'darkMode']),
    //     name() {
    //       return this.$store.getters['account/loginData']?.name ?? '관리자';
    //     },
    //     currentRouteName() {
    //       return this.$route.name;
    //     },
    //     currentDirectory() {
    //       let dir = this.$route.path.split('/')[1];
    //       if (dir.length > 0) {
    //         return dir.charAt(0).toUpperCase() + dir.slice(1);
    //       }
    //     }
    //   },
    //   created() {
    //     this.minNav;
    //   },
    //   beforeUpdate() {
    //     this.toggleNavigationOnMobile();
    //   },
    //   methods: {
    //     ...mapMutations('layout', ['navbarMinimize', 'toggleConfigurator']),
    //     ...mapActions('layout', ['toggleSidebarColor']),
    //     toggleNavigationOnMobile() {
    //       if (window.innerWidth < 1200) {
    //         this.navbarMinimize();
    //       }
    //     },
    //     changePassword() {
    //       this.$router.push('/change-password');
    //     },
    //     logout() {
    //       this.$store.dispatch('account/logout');
    //       this.$router.replace('/');
    //     }
    //   }
    // };

    return (_ctx, _cache) => {
      const _component_breadcrumbs = _resolveComponent("breadcrumbs");
      return _openBlock(), _createElementBlock("nav", _mergeProps({
        id: "navbarBlur",
        class: `${!_unref(isNavFixed) ? 'navbar navbar-main navbar-expand-lg px-0 mx-4 border-radius-xl shadow-none' : `navbar navbar-main navbar-expand-lg px-0 mx-4 border-radius-xl shadow-none position-sticky ${_unref(darkMode) ? 'bg-default' : 'bg-white'} left-auto top-2 z-index-sticky`} ${_unref(isRTL) ? 'top-0 position-sticky z-index-sticky' : ''}`
      }, _ctx.$attrs, {
        "data-scroll": "true"
      }), [_createElementVNode("div", _hoisted_1, [_createVNode(_component_breadcrumbs, {
        "current-page": _unref(currentRouteName),
        "current-directory": currentDirectory.value
      }, null, 8, ["current-page", "current-directory"]), _createElementVNode("div", {
        class: _normalizeClass(["sidenav-toggler sidenav-toggler-inner d-xl-block d-none", _unref(isRTL) ? 'me-3' : ''])
      }, [_createElementVNode("a", {
        href: "#",
        class: "p-0 nav-link text-body",
        onClick: _withModifiers(navbarMinimize, ["prevent"])
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("i", {
        class: _normalizeClass(["sidenav-toggler-line", _unref(isNavFixed) && !_unref(darkMode) ? ' opacity-8 bg-dark' : 'bg-white'])
      }, null, 2), _createElementVNode("i", {
        class: _normalizeClass(["sidenav-toggler-line", _unref(isNavFixed) && !_unref(darkMode) ? ' opacity-8 bg-dark' : 'bg-white'])
      }, null, 2), _createElementVNode("i", {
        class: _normalizeClass(["sidenav-toggler-line", _unref(isNavFixed) && !_unref(darkMode) ? ' opacity-8 bg-dark' : 'bg-white'])
      }, null, 2)])])], 2), _createElementVNode("div", {
        id: "navbar",
        class: _normalizeClass(["mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4", _unref(isRTL) ? 'px-0' : 'me-sm-4'])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["pe-md-3 d-flex align-items-center", _unref(isRTL) ? 'me-md-auto' : 'ms-md-auto'])
      }, null, 2), _createElementVNode("ul", _hoisted_3, [_createElementVNode("li", _hoisted_4, [_createElementVNode("a", {
        id: "iconNavbarSidenav",
        href: "#",
        class: "p-0 nav-link text-white",
        onClick: _withModifiers(navbarMinimize, ["prevent"])
      }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("i", {
        class: _normalizeClass(`sidenav-toggler-line ${_unref(isNavFixed) && !_unref(darkMode) ? ' opacity-8 bg-dark' : 'bg-white'}`)
      }, null, 2), _createElementVNode("i", {
        class: _normalizeClass(`sidenav-toggler-line ${_unref(isNavFixed) && !_unref(darkMode) ? ' opacity-8 bg-dark' : 'bg-white'}`)
      }, null, 2), _createElementVNode("i", {
        class: _normalizeClass(`sidenav-toggler-line ${_unref(isNavFixed) && !_unref(darkMode) ? ' opacity-8 bg-dark' : 'bg-white'}`)
      }, null, 2)])])]), _createElementVNode("li", {
        class: _normalizeClass(["nav-item dropdown d-flex align-items-center", _unref(isRTL) ? 'ps-2' : 'pe-2'])
      }, [_createElementVNode("a", {
        id: "dropdownMenuButton",
        href: "#",
        class: _normalizeClass(`p-0 nav-link ${_unref(isNavFixed) && !_unref(darkMode) ? ' opacity-8 text-dark' : 'text-white'} ${showMenu.value ? 'show' : ''}`),
        "data-bs-toggle": "dropdown",
        "aria-expanded": "false",
        onClick: _cache[0] || (_cache[0] = $event => showMenu.value = !showMenu.value)
      }, _toDisplayString(`${_unref(name)}님, 안녕하세요!`), 3), _createElementVNode("ul", {
        class: _normalizeClass(["px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4", showMenu.value ? 'show' : '']),
        "aria-labelledby": "dropdownMenuButton"
      }, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "dropdown-header noti-title"
      }, [_createElementVNode("h6", {
        class: "text-overflow m-0"
      }, "Welcome!")], -1)), _createElementVNode("li", {
        class: "mb-2"
      }, [_createElementVNode("a", {
        class: "dropdown-item border-radius-md",
        href: "javascript:;"
      }, [_createElementVNode("div", {
        class: "py-1 d-flex"
      }, [_createElementVNode("div", {
        class: "d-flex flex-column justify-content-center"
      }, [_createElementVNode("h6", {
        class: "mb-1 text-sm font-weight-normal",
        onClick: changePassword
      }, [...(_cache[1] || (_cache[1] = [_createElementVNode("i", {
        class: "ni ni-single-02"
      }, null, -1), _createElementVNode("span", {
        class: "font-weight-bold"
      }, "비밀번호 변경", -1)]))])])])])]), _createElementVNode("li", {
        class: "mb-2"
      }, [_createElementVNode("a", {
        class: "dropdown-item border-radius-md",
        href: "javascript:;"
      }, [_createElementVNode("div", {
        class: "py-1 d-flex"
      }, [_createElementVNode("div", {
        class: "d-flex flex-column justify-content-center",
        onClick: logout
      }, [...(_cache[2] || (_cache[2] = [_createElementVNode("h6", {
        class: "mb-1 text-sm font-weight-normal"
      }, [_createElementVNode("i", {
        class: "ni ni-user-run"
      }), _createElementVNode("span", {
        class: "font-weight-bold"
      }, "로그아웃")], -1)]))])])])])], 2)], 2)])], 2)])], 16);
    };
  }
};